<script lang="ts" setup>
import type { PromoCta } from '#core/types'

// image treatment differs per page (pre-login crops on mobile), so it stays
// overridable; the default matches the post-login usage.
withDefaults(defineProps<{
  imageClass?: string
  cropImageOnMobile?: boolean
}>(), {
  imageClass: 'object-cover object-[right_-100%]',
  cropImageOnMobile: false,
})

const items = [
  'Evaluate exchanges by primary and follow-on ranks and performance',
  'Learn about listing fees and requirements per exchange',
  'Get advisory from Forgd to validate your listing strategy',
]

const ctas: PromoCta[] = [{ label: 'View Data', to: '/list-on-exchanges' }]
</script>

<template>
  <CorePromoBanner
    :items="items"
    :ctas="ctas"
    image="/images/home/promo-exchange.webp"
    :image-class="imageClass"
    :crop-image-on-mobile="cropImageOnMobile"
  >
    <template #heading>
      Find the best path forward to your <span class="text-accent">token listing</span>
    </template>
    <template #intro>
      Whether you are planning your primary listing, or conducting a follow-on one, Forgd gives you the insights to find the best exchange for your token.
      <div class="text-secondary font-bold">
        <br>
        With Forgd you can...
      </div>
      <br>
    </template>
  </CorePromoBanner>
</template>
